export const FWU_ERROR_CODES = {
    GENERAL: 0x0a01,
    CHECK_BAD_URL_OR_BLOCK_COUNT: 0x0a02,
    CHECK_ERROR_DOWNLOAD_OR_PARSE: 0x0a03,
    START_NOT_FOUND_DATA: 0x0a04,
};
